import { JSONSchema7 } from 'json-schema';

const ValidationInfoSchema = async () => {
    let schema: JSONSchema7 = {
        title: 'ValidationInfoSchema',
        type: 'object',
        //
        definitions: {},
    };
    //
    schema = {
        properties: {
            className: {
                type: 'string',
            },
            invalidItems: {
                type: 'array',
            },
        },
        //
        ...schema,
    };
    //
    return schema;
};

export default ValidationInfoSchema;
